/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-11-18T17:50:48.079
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listkhmPayDeductionApplyItem,
	listkhmPayDeductionApplyItemInit,
	listkhmPayDeductionApplyItemByAuthorizations,
	deletekhmPayDeductionApplyItem
} from '@api/storagemanage/khmPayDeductionApplyItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listkhmPayDeductionApplyItem({
			state
		}) {
			return new Promise((resolve, reject) => {
				listkhmPayDeductionApplyItem(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listkhmPayDeductionApplyItemByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listkhmPayDeductionApplyItemByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listkhmPayDeductionApplyItemInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listkhmPayDeductionApplyItemInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deletekhmPayDeductionApplyItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deletekhmPayDeductionApplyItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
